import BaseService from "./BaseService";

class VoiceAIService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl);
  }

  isAIAgentsEnabled = async (companyId: string, locationId: string): Promise<boolean> => {
    try {
      let url = `/feature-flags/ai-agents?companyId=${companyId}&locationId=${locationId}`;
      const response = await this.requests.get(url);
      return response?.isEnabled || false
    } catch (err) {
      return false
    }
  }

}

const instance = new VoiceAIService(BaseService.servicesConfig.VoiceAI)
export default instance
